import { render, staticRenderFns } from "./GStatisticsFilter.vue?vue&type=template&id=49704f7d&scoped=true&"
import script from "./GStatisticsFilter.vue?vue&type=script&lang=ts&"
export * from "./GStatisticsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49704f7d",
  null
  
)

export default component.exports